import { render, staticRenderFns } from "./GridHistoryPerUser.vue?vue&type=template&id=2c582649"
import script from "./GridHistoryPerUser.vue?vue&type=script&lang=js"
export * from "./GridHistoryPerUser.vue?vue&type=script&lang=js"
import style0 from "./GridHistoryPerUser.vue?vue&type=style&index=0&id=2c582649&prod&lang=css"
import style1 from "./GridHistoryPerUser.vue?vue&type=style&index=1&id=2c582649&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports